import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { IconButton } from "@mui/material";
import { useEffect, useState, useCallback, useRef } from "react";
import { tokens } from "../../theme";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { Link } from "react-router-dom";
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { Select, MenuItem } from '@mui/material';
import { Button, DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite-no-reset.min.css';
import 'rsuite/dist/rsuite.min.css';
import { CustomProvider } from "rsuite";
import { MutatingDots } from 'react-loader-spinner'
import moment from 'moment';
import { API_BASE } from "../../api";

/** Keys this page stores in sessionStorage — never clear auth (`matrize_session`). */
const RESEARCHER_FILTER_STORAGE_KEYS = [
  "states",
  "districts",
  "researchers",
  "pc",
  "currentStateName",
  "currentStateId",
  "currentDistrictName",
  "currentPcName",
  "currentAcName",
  "currentPcId",
  "currentAcId",
  "currentDistId",
  "dateString",
  "totalSurvey",
  "completedSurvey",
  "currentCampaignName",
  "camp",
];

function clearResearchersPageSessionOnly() {
  RESEARCHER_FILTER_STORAGE_KEYS.forEach((key) =>
    sessionStorage.removeItem(key)
  );
}

const Researchers = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const controllerRef = useRef();
    const useSessionStorageState = (key, defaultValue) => {
        const storedValue = sessionStorage.getItem(key);
        const [state, setState] = useState(storedValue ? JSON.parse(storedValue) : defaultValue);
        useEffect(() => {
          sessionStorage.setItem(key, JSON.stringify(state));
        }, [key, state]);
      
        return [state, setState];
      };
    const [researchers, setResearchers] = useSessionStorageState('researchers',[]);
    const [states, setStates] = useSessionStorageState('states',[]);
    const [districts, setDistricts] = useSessionStorageState('districts',[]);
    const [currentStateName, setCurrentStateName] = useSessionStorageState('currentStateName', 'Select State');
    const [ currentCampaignName, setCurrentCampaignName] = useSessionStorageState('currentCampaignName','Select Campaign');
    const [camp, setCamp] = useSessionStorageState('camp',[]);
    const [currentCampId,setCurrentCampId] = useSessionStorageState('currentCampId',null);
    const [currentStateId, setCurrentStateId] = useSessionStorageState('currentStateId', null);
    const [currentDistrictName, setCurrentDistrictName] = useSessionStorageState('currentDistrictName', 'Select District');
    const [currentPcName, setCurrentPcName] = useSessionStorageState('currentPcName', 'Select Loksabha');
    const [currentAcName, setCurrentAcName] = useSessionStorageState('currentAcName', 'Select VidhanSabha');
    const [currentPcId, setCurrentPcId] = useSessionStorageState('currentPcId', null);
    const [currentAcId, setCurrentAcId] = useSessionStorageState('currentAcId', null);
    const [currentDistId, setCurrentDistId] = useSessionStorageState('currentDistId', null);
    const [filterDate, setFilterDate] =  useState([]);
    const [dateString, setDateString] = useSessionStorageState('dateString', null);
    const [totalSurvey, setTotalSurvey] = useSessionStorageState('totalSurvey', 0);
    const [completedSurvey, setCompletedSurvey] = useSessionStorageState('completedSurvey', 0);
    const [constituency, setConstituency] = useState([]); 
    const [assemblyList, setAssemblyList] = useState([]); //vidhansabha
    const [pc, setPc] = useSessionStorageState('pc',[]); //loksabha
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Save state to sessionStorage
        const saveStateToSessionStorage = () => {
        sessionStorage.setItem('states', JSON.stringify(states));  
        sessionStorage.setItem('districts', JSON.stringify(districts));
        sessionStorage.setItem('researchers', JSON.stringify(researchers));
        sessionStorage.setItem('pc', JSON.stringify(pc));
        sessionStorage.setItem('currentStateName', JSON.stringify(currentStateName));
        sessionStorage.setItem('currentStateId', JSON.stringify(currentStateId));
        sessionStorage.setItem('currentDistrictName', JSON.stringify(currentDistrictName));
        sessionStorage.setItem('currentPcName', JSON.stringify(currentPcName));
        sessionStorage.setItem('currentAcName', JSON.stringify(currentAcName));
        sessionStorage.setItem('currentPcId', JSON.stringify(currentPcId));
        sessionStorage.setItem('currentAcId', JSON.stringify(currentAcId));
        sessionStorage.setItem('currentDistId', JSON.stringify(currentDistId));
        // sessionStorage.setItem('filterDate', JSON.stringify(filterDate));
        sessionStorage.setItem('dateString', JSON.stringify(dateString));
        sessionStorage.setItem('totalSurvey', JSON.stringify(totalSurvey));
        sessionStorage.setItem('completedSurvey', JSON.stringify(completedSurvey));
        sessionStorage.setItem('currentCampaignName',JSON.stringify(currentCampaignName));
        sessionStorage.setItem('camp',JSON.stringify(camp));
        };
        // Call the saveStateToSessionStorage function whenever the state changes
        saveStateToSessionStorage();
      }, [
        researchers, states, districts, pc, currentStateName, currentStateId,
        currentDistrictName, currentPcName, currentAcName, currentPcId,
        currentAcId, currentDistId, loading, assemblyList, constituency,
        filterDate, dateString, totalSurvey, completedSurvey
      ]); 
    useEffect(() => {
        fetch(`${API_BASE}/states`).then(response => {
            return response.json()
        }).then(data => {
            setStates(data.result);
        })
    }, [])
    const fetchUserData = useCallback(async (signal,currentStateId,currentDistId,dateString, currentAcId, currentPcId,currentCampId) => {
        let url = `${API_BASE}/researchers?role=${props.role}`;
        if(currentStateId){
            url += `&state_id=${currentStateId}`;
        }if(currentDistId){
            url += `&districtId=${currentDistId}`
        }if(currentPcId){
            url += `&pcNo=${currentPcId}`;
        }if(currentAcId){
            url += `&acNo=${currentAcId}`;
        }if(currentCampId){
            url += `&campId=${currentCampId}`;
        }if(dateString){
            url += `&date=${dateString}`;
        }
        try {
            await fetch(url, { signal }).then((res) => {
                return res.json()}).then(data=>{               
                setResearchers(data.result);
                let ts = 0;
                let cs = 0;
                data?.result?.forEach((researcher)=>{
                    ts += researcher.totalSurveysCount;
                    cs += researcher.completedSurveysCount;
            })
            setTotalSurvey(ts);
            setCompletedSurvey(cs);
            })
            setLoading(false);
        }catch (error) {
            console.error('Error fetching data:', error);
          }
        }, []);

    const fetchDistrict = (currentStateId) => {
        fetch(`${API_BASE}/districts?state_id=${currentStateId}`)
            .then(response => response.json())
            .then(data => {
                setDistricts(data?.result.districtList);
                const uniquepc = new Set();
                data?.result?.assemblyList?.forEach(item => {
                    uniquepc.add(item.pc_name + '#' + item.pc_no);
                });
                setPc(Array.from(uniquepc));
                setConstituency(data?.result.assemblyList);
                setCurrentDistrictName('Select District');
                setCurrentDistId('');
                setCurrentPcName('Select Loksabha');
                setCurrentPcId('');
                setCurrentAcName('Select Vidhansabha');
                setCurrentAcId('');
            });
    };
    
    const fetchCamp = (currentStateId) =>{
        fetch(`${API_BASE}/campaigns?state_id=${currentStateId}`)
            .then(response => response.json())
            .then(data => {
                setCamp(data?.result);
            });
    }
    
    const fetchAcDist = (() => {
        if (currentDistId) {
            let acListDistrict = constituency?.filter((val) => val.dist_id === currentDistId);
            setAssemblyList(acListDistrict);
        }
    })

    const fetchAcPc = (() => {
        if (currentPcId) {
            let acListPC = constituency?.filter((val) => val.pc_no == currentPcId);
            setAssemblyList(acListPC);
        }
    })

    const generateReport = async () => {
        let reportUrl = `${API_BASE}/generateReport?role=${props.role}`;
        if(currentStateId){
            reportUrl += `&stateId=${currentStateId}`;
        }if(currentDistId){
            reportUrl += `&districtId=${currentDistId}`
        }if(currentPcId){
            reportUrl += `&pcNo=${currentPcId}`;
        }if(currentAcId){
            reportUrl += `&acNo=${currentAcId}`;
        }if(currentCampId){
            reportUrl += `&campId=${currentCampId}`;
        }if(dateString){
            reportUrl += `&date=${dateString}`;
        }
        try {
            const response = await fetch(reportUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();

                if (data.success === true) {
                    const csvContent = convertArrayToCSV(data.data);
                    const blob = new Blob([csvContent], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);

                    // Trigger the download link
                    const downloadLink = document.createElement('a');
                    downloadLink.href = url;
                    downloadLink.download = 'data.csv';
                    downloadLink.click();
                } else {
                    alert('No data for this state/district!!');
                }
            } else {
                alert('Failed to fetch data.');
            }
        } catch (error) {
            console.error('An error occurred:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const convertArrayToCSV = (array) => {
        if (array.length === 0) {
            return '';
        }
        const columnHeaders = extractColumnHeaders(array);
        const csvRows = [];
        csvRows.push(columnHeaders.join(','));
        array.forEach((obj) => {
            const row = columnHeaders.map((header) => {
                if (obj.hasOwnProperty(header)) {
                    return obj[header];
                } else {
                    return '';
                }
            });
            csvRows.push(row.join(','));
        });
        const csvContent = csvRows.join('\n');
        return csvContent;
    };

    const extractColumnHeaders = (array) => {
        const columnHeaders = new Set();
        array.forEach((obj) => {
            Object.keys(obj).forEach((key) => {
                columnHeaders.add(key);
            });
        });
        return Array.from(columnHeaders);
    };

    const downloadReport = (() => {
        generateReport();
    })
    const searchReasearchers = (() => {
        if(controllerRef.current){
            controllerRef.current.abort();
        }
        controllerRef.current = new AbortController();
        const signal = controllerRef.current.signal;
        setLoading(true);
        if(currentStateId){
        fetchUserData(signal, currentStateId, currentDistId, dateString, currentAcId, currentPcId,currentCampId);
        }
    })

    useEffect(() => {
        if (currentDistId !== null) {
            fetchAcDist();
        }
    }, [currentDistId]);

    useEffect(() => {
        if (currentPcId !== null) {
            fetchAcPc();
        }
    }, [currentPcId])

    // Handlers
    const handleState = (event) => {
        const selectedName = states.find((state) => state.id === event.target.value)?.name;
        setCurrentStateName(selectedName);
        setCurrentStateId(event.target.value);
        setCurrentAcName('Select Vidhansabha');
        setCurrentAcId('');
        setCurrentPcName('Select Loksabha');
        setCurrentPcId('');
        setCurrentDistId('');
        setCurrentDistrictName('Select District');
        setCurrentCampaignName('Select Campaign')
        setCurrentCampId('')
        fetchDistrict(event.target.value);
        fetchCamp(event.target.value);

    };

    const handleCamp = (event) => {
        const selectedName = camp.find((cmp) => cmp.id === event.target.value)?.title;
        setCurrentCampaignName(selectedName);
        setCurrentCampId(event.target.value);
    };

    const handleDistrict = (event) => {
        const selectedName = districts.find((district) => district.id === event.target.value)?.name;
        setCurrentDistrictName(selectedName);
        setCurrentDistId(event.target.value)
        setCurrentAcName('Select Vidhansabha');
        setCurrentAcId('');
        setCurrentPcName('Select Loksabha');
        setCurrentPcId('');
    };
    //loksabha handler
    const handlePc = (event) => {
        const selectedName = pc.find((p) => p.split('#')[1] === event.target.value).split('#')[0];
        setCurrentPcName(selectedName);
        setCurrentPcId(event.target.value);
        setCurrentAcName('Select Vidhansabha');
        setCurrentAcId('');
        setCurrentDistId('');
        setCurrentDistrictName('Select District');
    }
    //vidhansabha handler
    const handleAc = (event) => {
        const selectedName = assemblyList.find((a) => a.ac_no === event.target.value)?.ac_name;
        setCurrentAcName(selectedName);
        setCurrentAcId(event.target.value);
    }
    const handleDateChange = (value) => {
        if(!value){
            setDateString(null)
            setFilterDate([]);

        }
        
        const abortController = new AbortController();
        const signal = abortController.signal;
        if(value){
        const date = moment(value[0]).format('YYYY-MM-DD') + '#' + moment(value[1]).format('YYYY-MM-DD'); 

        setFilterDate([value[0], value[1]]);
        setDateString(encodeURIComponent(date));
        setLoading(true);
        fetchUserData(signal, currentStateId, currentDistId,encodeURIComponent(date),currentAcId, currentPcId,currentCampId);
        return () => abortController.abort(); 
    }
    };

    const columns = [
        {
            field: "id",
            headerName: "ID",
            flex: 0.5,
            renderCell: (row) => <Link to={`/surveys/${row.id + '&' + currentStateId + '&' + currentDistId+ '&' + currentAcId+ '&' + currentPcId+ '&'+ currentCampId+ '&'+ dateString}`} >{row.id}</Link>
        },

        {
            field: "name",
            headerName: `Name [ Total - ${researchers?.length} ]`,
            flex: 1,
            cellClassName: "name-column--cell",
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
        },
        {
            field: "phone",
            headerName: "Phone Number",
            flex: 1,
        },
        {
            field: `totalSurveysCount`,
            headerName: `Total Survey(s) [ ${totalSurvey} ]`,
            flex: 1,
            
        },
        {
            field: "completedSurveysCount",
            headerName: `Completed Survey(s) [ ${completedSurvey} ]`,
            flex: 1,
        },
    ];

    return (
        <>
            <Box display="flex" justifyContent="flex-start" width="90%" p={2}>
                {/* state */}
                <Box
                    display="flex"
                    backgroundColor={colors.primary[400]}
                    borderRadius="3px"
                    width="250px"
                    marginRight="20px"
                >

                    <Select
                        sx={{
                            ml: 2,
                            flex: 1,
                            minWidth: '100px',
                            marginLeft: '0px'
                        }}
                        onChange={handleState}
                        value={currentStateName}
                    >
                        <MenuItem value={currentStateName} disabled>
                            {currentStateName}
                        </MenuItem>
                        {states && states.map((state) => (
                            <MenuItem key={state.id} value={state.id}>
                                {state.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                {/* camp id */}
                <Box
                    display="flex"
                    backgroundColor={colors.primary[400]}
                    borderRadius="3px"
                    width="250px"
                    marginRight="20px"
                >

                    <Select
                        sx={{
                            ml: 2,
                            flex: 1,
                            minWidth: '100px',
                            marginLeft: '0px'
                        }}
                        onChange={handleCamp}
                        value={currentCampaignName}
                    >
                        <MenuItem value={currentCampaignName} disabled>
                            {currentCampaignName}
                        </MenuItem>
                        {camp && camp.map((cmp) => (
                            <MenuItem key={cmp.id} value={cmp.id}>
                                {cmp.title}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                {/* district */}
                {
                    districts ? (
                        <Box
                            display="flex"
                            backgroundColor={colors.primary[400]}
                            borderRadius="3px"
                            width="250px"
                            marginRight="20px"
                        >
                            <Select
                                sx={{
                                    ml: 2,
                                    flex: 1,
                                    minWidth: '100px',
                                    marginLeft: '0px'
                                }}
                                onChange={handleDistrict}
                                value={currentDistrictName}

                            >
                                <MenuItem value={currentDistrictName} disabled>
                                    {currentDistrictName}
                                </MenuItem>
                                {districts && districts.map((district) => (
                                    <MenuItem key={district.id} value={district.id}>
                                        {district.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Box>
                    ) : null
                }
                {/* loksabha (PC) */}
                {(pc?.length > 0) ? (
                    <Box
                        display="flex"
                        backgroundColor={colors.primary[400]}
                        borderRadius="3px"
                        width="250px"
                        marginRight="20px"
                    >
                        <Select
                            sx={{
                                ml: 2,
                                flex: 1,
                                minWidth: '100px',
                                marginLeft: '0px'
                            }}
                            onChange={handlePc}
                            value={currentPcName}

                        >
                            <MenuItem value={currentPcName} disabled>
                                <em>{currentPcName}</em>
                            </MenuItem>
                            {pc && pc?.map((item) => (
                                <MenuItem key={item.split('#')[1]} value={item.split('#')[1]}>
                                    {item.split('#')[0]}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>) : null}

                {/* vidhansabha  */}
                {(assemblyList?.length > 0) ? (
                    <Box
                        display="flex"
                        backgroundColor={colors.primary[400]}
                        borderRadius="3px"
                        width="250px"
                        marginRight="20px"
                    >
                        <Select
                            sx={{
                                ml: 2,
                                flex: 1,
                                minWidth: '100px',
                                marginLeft: '0px'
                            }}
                            onChange={handleAc}
                            value={currentAcName}

                        >
                            <MenuItem value={currentAcName} disabled>
                                <em>{currentAcName}</em>
                            </MenuItem>
                            {assemblyList.map((assembly) => (
                                <MenuItem key={assembly.ac_no} value={assembly.ac_no}>
                                    {assembly.ac_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>) : null}
                {/* RIGHT SIDE ICONS */}
                <Button type="button" className="re_custom_btn" onClick={searchReasearchers}><SearchIcon/></Button>
                <Button
                  type="button"
                  className="re_custom_btn_clear"
                  onClick={() => {
                    clearResearchersPageSessionOnly();
                    window.location.reload();
                  }}
                >
                  <ClearIcon />
                </Button>
                <Box display="flex" position="absolute" right="1%">
                    {(filterDate || currentStateId) ? (<IconButton onClick={downloadReport}> <DownloadIcon /></IconButton>) : null}

                    <IconButton>
                        <PersonOutlinedIcon />
                    </IconButton>
                </Box>
            </Box>
            {currentStateId != null ? (
            <Box display="flex" justifyContent="flex-start" width="90%" p={2}>
                <CustomProvider theme="light">
                    <DateRangePicker
                        value={filterDate}
                        onChange={handleDateChange}
                        cleanable={true} // Add a clear button
                        format="d.MM.yy" // Set the date format as desired
                        placeholder={'Start Date - End Date'}
                        style={{ paddingBottom: '20px !important' }}
                    />
                </CustomProvider>
            </Box> ) : null}
            <Box ml="20px">
                <Header
                    title={`Researchers (${researchers?.length})`}
                />
                <Box
                    m="40px 0 0 0"
                    height="75vh"
                    sx={{
                        "& .MuiDataGrid-root": {
                            border: "none",
                        },
                        "& .MuiDataGrid-cell": {
                            borderBottom: "none",
                        },
                        "& .name-column--cell": {
                            color: colors.greenAccent[300],
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: colors.blueAccent[700],
                            borderBottom: "none",
                        },
                        "& .MuiDataGrid-virtualScroller": {
                            backgroundColor: colors.primary[400],
                        },
                        "& .MuiDataGrid-footerContainer": {
                            borderTop: "none",
                            backgroundColor: colors.blueAccent[700],
                        },
                        "& .MuiCheckbox-root": {
                            color: `${colors.greenAccent[200]} !important`,
                        },
                        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                            color: `${colors.grey[100]} !important`,
                        },
                    }}
                >
                    {!loading ? (<DataGrid
                        rows={researchers}
                        columns={columns}
                        components={{ Toolbar: GridToolbar }}
                        className="customDataGrid"
                    />) :
                        (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}> <MutatingDots
                            height="100"
                            width="100"
                            color="#ED3237"
                            secondaryColor='#ED3237'
                            radius='12.5'
                            ariaLabel="mutating-dots-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            style={{
                                left: "30%",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "50%",
                                boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                            }}
                        /></div>)}
                </Box>
            </Box>
        </>
    );
}
export default Researchers;
